import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { InvestorViewerCommand, ViewerMovement } from '../../../../../../core/models/api.models';
import { StateCardComponent } from '../../../../shared/state-card/state-card.component';
import { formatBoolean, formatCurrency, formatDate, formatNumber, formatPercentage, formatText } from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-viewer-commands-section',
  imports: [StateCardComponent, InvestorViewerAccordionComponent],
  templateUrl: './investor-viewer-commands-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../investor-viewer-section.shared.scss',
})
export class InvestorViewerCommandsSectionComponent {
  readonly commands = input<InvestorViewerCommand[] | null>(null);
  readonly loading = input(false);
  readonly error = input<string | null>(null);

  protected readonly formatText = formatText;
  protected readonly formatDate = formatDate;
  protected readonly formatNumber = formatNumber;
  protected readonly formatCurrency = formatCurrency;
  protected readonly formatPercentage = formatPercentage;
  protected readonly formatBoolean = formatBoolean;

  protected getCommandTitle(command: InvestorViewerCommand): string {
    return command.name?.trim() || `Commande #${command.commandId}`;
  }

  protected getMovementTitle(movement: ViewerMovement): string {
    return movement.natureMovementLabel?.trim() || `Mouvement #${movement.movementId}`;
  }
}
